import React from 'react';

import FaqAccordion from './FaqAccordion';
import ReactMarkdown from 'react-markdown/with-html';
import type { FaqSection } from '../../models/Types';

export type Mandate = {
  title: string;
  text: string;
  ordering: number;
};

type Props = {
  mandates: Array<Mandate>;
  title?: string;
};

const DEFAULTS = {
  TITLE: '',
};

export default function MultiMandate({ mandates, title }: Props) {
  const faqSectionsFromMandates = mandates
    .sort((mandateA, mandateB) => mandateA.ordering - mandateB.ordering)
    .map(
      (mandate): FaqSection => ({
        label: mandate.title,
        description: <ReactMarkdown escapeHtml linkTarget="_blank" source={mandate.text} />,
      }),
    );

  return <FaqAccordion title={title || DEFAULTS.TITLE} sections={faqSectionsFromMandates} />;
}
